import type { FieldRegistryConfig } from "../../types";
import type { AssignToFieldValue, AssignToFormValue } from "./assign-to.config";

/**
 * Lives apart from the field config so the control can use it without importing the config,
 * which imports the control.
 */
export const prefillAssignTo: NonNullable<
  FieldRegistryConfig<AssignToFormValue[], AssignToFieldValue>["prefill"]
> = ({ value, field, members }) => {
  const membersIds = value.split(",");

  const selectedMembers = members?.filter(
    (member) => membersIds.includes(member.id.toString()) || membersIds.includes(member.name),
  );

  if (!selectedMembers?.length || !members?.length) return null;

  if (field.params.entries_allowed === "multiple") {
    return selectedMembers;
  }

  return [selectedMembers[0]];
};
